import { PersistConfig } from "redux-persist";
import storage from 'redux-persist/lib/storage';
const persistConfigDynamic: PersistConfig<any> = {
  key: 'dynamic',
  storage: storage,
  blacklist: ['userRolesReducer'], // Prevents persistence of userRoles inside dynamic
};

export default persistConfigDynamic;